import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || '',
  release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'development',
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  initialScope: {
    tags: { service: 'web' },
  },
});

export { Sentry };
